export default __webpack_public_path__ + "static/media/three_dots_icon.16cf54c2.svg";